// src/utils/forms/accordionHelper.js

/**
 * ✅ Create accordion handler that supports multiple open panels
 * @param {Function} setExpandedPanel - State setter function
 * @param {boolean} allowMultiple - Allow multiple panels to be open (default: true)
 */
export const createAccordionHandler = (setExpandedPanel, allowMultiple = true) => {
    return (panel) => (event, isExpanded) => {
        if (allowMultiple) {
            // ✅ Multiple panels can be open
            setExpandedPanel((prev) => {
                if (Array.isArray(prev)) {
                    // If it's already an array
                    if (isExpanded) {
                        // Add panel to array if not exists
                        return prev.includes(panel) ? prev : [...prev, panel];
                    } else {
                        // Remove panel from array
                        return prev.filter((p) => p !== panel);
                    }
                } else {
                    // Convert single value to array
                    if (isExpanded) {
                        return [prev, panel].filter(Boolean);
                    } else {
                        return [];
                    }
                }
            });
        } else {
            // ✅ Only one panel can be open (old behavior)
            setExpandedPanel(isExpanded ? panel : false);
        }
    };
};

/**
 * ✅ Check if panel is expanded (works with both array and single value)
 */
export const isPanelExpanded = (expandedPanel, panel) => {
    if (Array.isArray(expandedPanel)) {
        return expandedPanel.includes(panel);
    }
    return expandedPanel === panel;
};
